/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Upcharges/UpchargeService',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery.proxyRequest'
], function ($, lodash, Roc) {
    'use strict';

    /**
     * Issues a request to add or update an upcharge associated to an order
     * @param {String} code - The upcharge code to associate
     * @param {Number} upchargeAmount - The monetary amount change to apply to the order
     * @param {} data - A JSON string or object associated to the upcharge
     * @returns {} 
     */
    function addOrderUpcharge(code, upchargeAmount, data) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/order/{orderId}',
            data: JSON.stringify(_convertUpcharge(code, upchargeAmount, data)),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> addOrderUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Issues a request to remove an upcharge associated to an order
     * @param {String} code - The upcharge code to remove
     * @returns {} 
     */
    function removeOrderUpcharge(code) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/remove/order/{orderId}',
            data: JSON.stringify({ "code": code }),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> removeOrderUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Issues a request to add or update an upcharge associated to a recipient
     * @param {} id - The recipient for the upcharge
     * @param {String} code - The upcharge code to associate
     * @param {Number} upchargeAmount - The monetary amount change to apply to the recipient
     * @param {} data - A JSON string or object associated to the upcharge
     * @returns {} 
     */
    function addRecipientUpcharge(id, code, upchargeAmount, data) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/recipient/{orderId}/' + id,
            data: JSON.stringify(_convertUpcharge(code, upchargeAmount, data)),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> addRecipientUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Issues a request to remove an upcharge associated to a recipient
     * @param {} id - The recipient with the upcharge
     * @param {String} code - The upcharge code to remove
     * @returns {} 
     */
    function removeRecipientUpcharge(id, code) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/remove/recipient/{orderId}/' + id,
            data: JSON.stringify({ "code": code }),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> removeRecipientUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Issues a request to add or update an upcharge associated to an order item
     * @param {} id - The order item for the upcharge
     * @param {String} code - The upcharge code to associate
     * @param {Number} upchargeAmount - The monetary amount change to apply to the order item
     * @param {} data - A JSON string or object associated to the upcharge
     * @returns {} 
     */
    function addItemUpcharge(id, code, upchargeAmount, data) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/item/{orderId}/' + id,
            data: JSON.stringify(_convertUpcharge(code, upchargeAmount, data)),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> addItemUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    /**
     * Issues a request to remove an upcharge associated to an order item
     * @param {} id - The order item with the upcharge
     * @param {String} code - The upcharge code to remove
     * @returns {} 
     */
    function removeItemUpcharge(id, code) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/upcharge/remove/item/{orderId}/' + id,
            data: JSON.stringify({ "code": code }),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> removeItemUpcharge');
                Roc.Logger.info(xhr);
            }
        });
    }

    function _convertUpcharge(code, upchargeAmount, data) {
        if ($.type(data) !== "string") {
            data = JSON.stringify(data);
        }

        var request = {
            "code": code,
            "upchargeAmount": upchargeAmount,
            "json": data,
        };
        return request;
    }

    /**
     * A module for making shopping cart api requests related to upcharges.
     * @exports UpchargeService
     */
    var UpchargeService = {
        addOrderUpcharge: addOrderUpcharge,
        removeOrderUpcharge: removeOrderUpcharge,
        addRecipientUpcharge: addRecipientUpcharge,
        removeRecipientUpcharge: removeRecipientUpcharge,
        addItemUpcharge: addItemUpcharge,
        removeItemUpcharge: removeItemUpcharge
    };

    Roc.Logger.debug('UpchargeService.js Loaded:', UpchargeService);

    return UpchargeService;
});

